import { AnimationEvent } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import {
  BasketNotification,
  BasketNotificationInputs,
  BasketNotificationOutputs,
} from '@epicuro-next/models/basket';
import { RecommendationsPanels } from '@epicuro-next/models/recommendation-panels';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { go } from '@epicuro-next/state/router-store';
import { slideFromRight } from '@epicuro-next/ui';
import { Store } from '@ngrx/store';
import { Severity, ValidationResult } from 'graphql-api/baskets-api-interfaces';

const selector = 'epc-basket-notification';

@DynamicComponentRegister(selector, true)
@Component({
  selector,
  templateUrl: './basket-notification.component.html',
  styleUrls: ['./basket-notification.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideFromRight],
})
export class BasketNotificationComponent
  implements BasketNotificationInputs, BasketNotificationOutputs
{
  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly store: Store,
  ) {}
  public readonly RecommendationsPanels = RecommendationsPanels;
  public imageMaxSizes = IMAGE_MAX_SIZES;

  @Input()
  public notification: BasketNotification | null = null;

  @Input()
  public basketLink: string[] = [];

  @Input()
  public showNavigateToBasketButton = true;

  @Input()
  public basketValidationErrors: ValidationResult[] = [];

  @Input()
  public basketButtonText = $localize`:BasketNotification|Basket notification button text@@basketNotificationBtnText:Added to basket`;

  @Input()
  public options = {
    hideRecommendationPanel: false,
    hideCloseButton: false,
    hideProductImage: false,
    hideNumbers: false,
    hideProductId: false,
    hideAddedToBasketMessage: true,
  };

  @Input()
  public additionalCssClasses: string | null = 'shadow-lg';

  @Input()
  public additionalViewBasketButtonClasses: string | null =
    'btn-primary btn-block rounded-0';

  @Output()
  public clearNotification = new EventEmitter();

  @Output()
  public navigatingToBasket = new EventEmitter();

  protected readonly SEVERITY = Severity;

  public onAnimationDone(evt: AnimationEvent) {
    if (evt.fromState === null) {
      this.clearNotification.emit();
    }
  }

  public trimWhitespace(value: string) {
    return value.replace('\xa0\xa0', '\xa0').trim();
  }

  public navigateToBasket() {
    this.navigatingToBasket.emit();

    this.close();

    this.store.dispatch(
      go({
        commands: this.basketLink,
      }),
    );
  }

  public close() {
    this.notification = null;
    this.cdr.markForCheck();
  }
}
